import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import ElementCatalogTree from "./ElementCatalogTree";
import { Link } from "react-router-dom";
import Searchbox from "../../Misc/Searchbox";

export default class ElementCatalog extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      search: "",
      catalogItems: null,
      catalogItemsSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "ship.specification",
          rstr: ")",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadCatalog();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.loadCatalog();
    }
  }

  handleSearch = (v) => {
    this.setState({ search: v });
  };

  loadCatalog = async () => {
    let { catalogItemsSearchDefault } = this.state;
    this.setState({ pending: true });

    let shipItem = {};
    if (this.props.shipId && this.props.shipId !== "any") {
      shipItem = await this.context.api.q("/ship/get", {
        id: this.props.shipId,
      });
    }
    const projectId = shipItem.project || null;

    let search = catalogItemsSearchDefault.slice();
    search.push({
      field: "project",
      compare: "EQL",
      value: projectId,
    });

    let catalogItems = await this.context.api.qoo(
      `/specification/tree`,
      {
        project: projectId,
        ship: shipItem.id,
        filter: { visible: true, statetypecode: "enabled" },
      },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );
    this.setState({ pending: false, catalogItems });
  };

  render() {
    const { shipId, specId } = this.props;
    let { catalogItems, search } = this.state;
    let displayItems = {};
    if (search) {
      Object.entries(catalogItems).forEach(([id, item]) => {
        let searchReg = new RegExp(this.context.api.regexEscape(search), "i");
        if (item.label.search(searchReg) > -1) {
          displayItems[id] = { ...item, node: null, level: 1 };
        }
      });
    } else {
      displayItems = catalogItems;
    }

    return (
      <>
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          {this.state.catalogItems ? (
            <>
              <div className="mb-3">
                <Searchbox
                  placeholder="Поиск в структуре..."
                  onSearch={this.handleSearch}
                  timeout={500}
                />
              </div>
              {shipId && shipId !== "any" && (
                <div
                  className={`p-1 bg-hover-light ${
                    specId === "any" && "bg-light"
                  }`}
                >
                  <Link
                    className={` d-block text-dark   ${
                      specId === "any" && "bg-light "
                    }`}
                    to={`/element/${shipId}`}
                  >
                    <i className="fa fa-list mr-3"></i> Все
                  </Link>
                </div>
              )}

              <ElementCatalogTree items={displayItems} {...this.props} />
            </>
          ) : null}
        </Blocker>
      </>
    );
  }
}
